export  class ServerResponse{
    code: number
    data: any
    error: string;
    message: string;
    status: string
}